import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const InfoModal = (props) => {
	return (
		<Modal isOpen={props.show} toggle={props.toggle}>
			<ModalHeader>{props.text.title}</ModalHeader>
			<ModalBody>
				{props.text.extraMsg &&
					<p>{props.text.extraMsg}</p>
				}
				<p>{props.text.text}</p>
			</ModalBody>
			<ModalFooter>
				<Button color="success" onClick={() => props.toggle()}>
					OK
				</Button>
			</ModalFooter>
		</Modal>
	);
};

export default InfoModal;
